import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';

type MenuKey = keyof ModelLocatorService['menu'];

interface FooterMenuItem {
    route: string;
    icon: { src: string; type: 'svg' | 'img' };
    tag?: string;
    label: string;
    condition?: MenuKey;
    profiles?: number[];
    excludedProfiles?: number[];
    hidden: boolean;
    disabled: boolean;
}

@Component({
    selector: 'app-mm-menu-footer',
    templateUrl: './mm-menu-footer.component.html',
    styleUrls: ['./mm-menu-footer.component.scss'],
})
export class MmMenuFooterComponent {
    public menuFooter: FooterMenuItem[] = [
        {
            route: '/home',
            icon: { src: '../../assets/icon/icone_interacao.svg', type: 'svg' },
            label: 'INTERAÇÃO',
            condition: 'interacao',
            hidden: false,
            disabled: false,
        },
        {
            route: '/challenges',
            icon: { src: '../../assets/icon/icone_superacao.svg', type: 'svg' },
            label: 'DESAFIOS',
            hidden: false,
            disabled: false,
        },
        {
            route: '/store',
            icon: { src: '../../assets/icon/icone_store.svg', type: 'svg' },
            label: 'LOJA',
            condition: 'premiacao',
            hidden: false,
            disabled: false,
        },
        {
            route: '/my-points',
            icon: { src: '../../assets/icon/icone_pontos.svg', type: 'svg' },
            label: 'PONTUAÇÃO',
            condition: 'pontuacao',
            profiles: [15],
            hidden: false,
            disabled: false,
        },
        {
            route: '/multi-awards',
            icon: { src: '../../assets/icon/icone_multipremios.svg', type: 'svg' },
            label: 'MULTIPRÊMIOS',
            condition: 'multipremios',
            excludedProfiles: [5],
            hidden: false,
            disabled: false,
        },
        {
            route: '/multiluck',
            icon: { src: '../../assets/icon/icone_multipremios.svg', type: 'svg' },
            tag: '../../assets/image/tag_novo.png',
            label: 'MULTISORTE',
            condition: 'multisorte',
            profiles: [5, 14, 17, 18, 19],
            hidden: false,
            disabled: false,
        },
        {
            route: '/help',
            icon: { src: '../../assets/icon/icone_suporte.svg', type: 'svg' },
            label: 'SUPORTE',
            condition: 'suporte',
            hidden: false,
            disabled: false,
        },
    ];

    constructor(
        public modelLocator: ModelLocatorService,
        public platform: Platform,
        private router: Router
    ) {
    }

    touchGoToRoute(item: FooterMenuItem): void {
        if (item.disabled) return;
        this.router.navigate([item.route]);
    }

    /**
     * Returns true if the menu item is enabled, allowed for the current profile and not hidden.
     * @param item - footer menu item with optional condition key and profile lists
     */
    getCondition(item: FooterMenuItem): boolean {
        const idperfil = Number(this.modelLocator.dadosLogin?.idperfil);
        if (item.condition && !this.modelLocator.menu[item.condition]) return false;
        if (item.profiles && !item.profiles.includes(idperfil)) return false;
        if (item.excludedProfiles?.includes(idperfil)) return false;
        return !item.hidden;
    }
}
